import { ReactNode } from 'react';
import {
    Avatar,
    Card,
    CardContent,
    CardProps,
    Skeleton,
    Stack,
    SvgIcon,
    Typography,
} from '@mui/material';

type BaseData = {
    value: string;
};

type DataBadgeProps = {
    sx?: CardProps['sx'];
    title: string;
    data: BaseData;
    avatarIcon: ReactNode;
    avatarColor: string;
    loading?: boolean;
};

export function DataBadge({
    sx,
    title,
    data,
    avatarIcon,
    avatarColor,
    loading = true,
}: DataBadgeProps) {
    const { value } = data;

    return (
        <Card
            sx={{
                ...sx,
                minHeight: 140,
            }}
        >
            <CardContent>
                <Stack
                    alignItems='flex-start'
                    direction='row'
                    justifyContent='space-between'
                    spacing={3}
                >
                    <Stack spacing={1}>
                        <Typography color='text.secondary' variant='overline'>
                            {title}
                        </Typography>
                        <Typography variant='h4'>
                            {loading ? (
                                <Skeleton width={140} animation='wave' />
                            ) : (
                                value
                            )}
                        </Typography>
                    </Stack>
                    <Avatar
                        sx={{
                            backgroundColor: avatarColor,
                            height: 56,
                            width: 56,
                        }}
                    >
                        <SvgIcon fontSize='large'>{avatarIcon}</SvgIcon>
                    </Avatar>
                </Stack>
            </CardContent>
        </Card>
    );
}
